import { CommonModule, registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppMaterialModule } from './app-material.module';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FilesModalComponent } from './components/files-modal/files-modal.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { TableauDialogComponent } from './components/tableau-dialog/tableau-dialog.component';
import { OtpInputComponent } from './components/opt-input/otp-input.component';
import { PillButtonComponent } from './components/pill-button/pill-button.component';
import { SegmentedToggleComponent } from './components/segmented-toggle/segmented-toggle.component';

import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { TooltipContainerComponent } from './directives/tooltip/tooltip-container.component';
import { TruncateTooltipDirective } from './directives/truncate-tooltip/truncate-tooltip.directive';

import { SlugifyPipe } from './pipes/slugify.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    RouterModule,
  ],
  exports: [
    DropdownComponent,
    ProgressSpinnerComponent,
    AppMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SlugifyPipe,
    FontAwesomeModule,
    OtpInputComponent,
    TooltipDirective,
    PillButtonComponent,
    SegmentedToggleComponent,
    TruncateTooltipDirective,
  ],
  declarations: [
    DropdownComponent,
    ProgressSpinnerComponent,
    SlugifyPipe,
    TableauDialogComponent,
    OtpInputComponent,
    FilesModalComponent,
    TooltipDirective,
    TooltipContainerComponent,
    PillButtonComponent,
    SegmentedToggleComponent,
    TruncateTooltipDirective,
  ],
  providers: [SlugifyPipe],
  entryComponents: [
    TableauDialogComponent,
    OtpInputComponent,
    FilesModalComponent,
    TooltipContainerComponent,
  ],
})
export class SharedModule {}
